import React, { Component } from "react";
import { Link } from "react-router-dom";
import ClientBadge from "./ClientBadge.js";

class Returnnotification extends Component {
  constructor(props) {
    super(props);
    this.state = { modal: false, isLoading: false };
  }

  getStatusIcon(status) {
    switch (status) {
      case "1":
        return (
          <div className="bg-info text-white rounded-circle flex aspect-square justify-center items-center">
            <i className="fas fa-sharp fa-hourglass-half"></i>
          </div>
        );
      case "2":
        return (
          <div className="bg-warning text-white rounded-circle flex aspect-square justify-center items-center">
            <i className="fas fa-sharp fa-hourglass-half"></i>
          </div>
        );
      case "3":
        return (
          <div className="bg-danger text-white rounded-circle flex aspect-square justify-center items-center">
            <i className="fa fa-duotone fa-solid fa-thumbs-down"></i>
          </div>
        );
      case "4":
        return (
          <div className="bg-success text-white rounded-circle flex aspect-square justify-center items-center">
            <i className="fa fa-duotone fa-solid fa-thumbs-up"></i>
          </div>
        );
      default:
        return (
          <div className="bg-primary text-white rounded-circle flex aspect-square justify-center items-center">
            <i className="fas fa-solid fa-question"></i>
          </div>
        );
    }
  }

  render() {
    if (this.props.empty) {
      return (
        <>
          <div className="returned noReturns">
            <div className="ReturnDetails">
              <div className="ReturnTitle">Geen openstaande acties</div>
            </div>
          </div>
          <Link to="/retouren" className="text-left pl-4 py-3 text-underline">
            Bekijk alle retouren
          </Link>
        </>
      );
    }

    const { retour } = this.props;

    return (
      <Link to="/retouren" className="returned">
        <div className="returnStatus">
          {this.getStatusIcon(retour.return_status)}
        </div>
        <div className="ReturnDetails">
          <div className="ReturnTitle">{retour.product_name}</div>
          <div className="returnSubs">
            <div className="ReturnUnit">DOOS</div>
            <ClientBadge
              clientId={retour.return_client_id}
              className="ReturnSection"
            />
          </div>
        </div>
        <div>
          <i className="fa fa-regular fa-chevron-right go"></i>
        </div>
      </Link>
    );
  }
}

export default Returnnotification;
